import { Link } from 'react-router-dom';

import { BuildVersion } from './BuildVersion';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="mt-auto"
      style={{
        background: '#1a1a1a',
        color: '#ede5d4',
        position: 'relative',
      }}
    >
      {/* Torn paper edge */}
      <div
        style={{
          position: 'absolute',
          top: '-8px',
          left: 0,
          right: 0,
          height: '8px',
          background: `linear-gradient(135deg, #f5f0e8 33.33%, transparent 33.33%) -12px 0,
                       linear-gradient(225deg, #f5f0e8 33.33%, transparent 33.33%) -12px 0`,
          backgroundSize: '24px 8px',
        }}
      />

      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div
                style={{
                  width: 32,
                  height: 32,
                  background: '#d62828',
                  border: '2px solid #ede5d4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transform: 'rotate(-3deg)',
                }}
              >
                <svg
                  className="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={3}
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span
                style={{
                  fontFamily: "'Permanent Marker', cursive",
                  fontSize: '20px',
                  color: '#fefcf6',
                }}
              >
                VotePlan
              </span>
            </div>
            <p
              style={{
                fontFamily: "'Patrick Hand', cursive",
                fontSize: '15px',
                color: '#bfb49e',
                lineHeight: 1.4,
              }}
            >
              Know your vote. Use your voice. Nobody does this for you.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3
              style={{
                fontFamily: "'Permanent Marker', cursive",
                fontSize: '16px',
                color: '#fcbf49',
                marginBottom: '1rem',
              }}
            >
              GO
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/elections"
                  className="transition-colors active:opacity-75"
                  style={{
                    fontFamily: "'Patrick Hand', cursive",
                    fontSize: '15px',
                    color: '#bfb49e',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fefcf6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#bfb49e';
                  }}
                >
                  Elections
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="transition-colors active:opacity-75"
                  style={{
                    fontFamily: "'Patrick Hand', cursive",
                    fontSize: '15px',
                    color: '#bfb49e',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fefcf6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#bfb49e';
                  }}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="transition-colors active:opacity-75"
                  style={{
                    fontFamily: "'Patrick Hand', cursive",
                    fontSize: '15px',
                    color: '#bfb49e',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fefcf6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#bfb49e';
                  }}
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3
              style={{
                fontFamily: "'Permanent Marker', cursive",
                fontSize: '16px',
                color: '#fcbf49',
                marginBottom: '1rem',
              }}
            >
              FINE PRINT
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="transition-colors active:opacity-75"
                  style={{
                    fontFamily: "'Patrick Hand', cursive",
                    fontSize: '15px',
                    color: '#bfb49e',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fefcf6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#bfb49e';
                  }}
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="transition-colors active:opacity-75"
                  style={{
                    fontFamily: "'Patrick Hand', cursive",
                    fontSize: '15px',
                    color: '#bfb49e',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fefcf6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#bfb49e';
                  }}
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/accessibility"
                  className="transition-colors active:opacity-75"
                  style={{
                    fontFamily: "'Patrick Hand', cursive",
                    fontSize: '15px',
                    color: '#bfb49e',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fefcf6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#bfb49e';
                  }}
                >
                  Accessibility
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3
              style={{
                fontFamily: "'Permanent Marker', cursive",
                fontSize: '16px',
                color: '#fcbf49',
                marginBottom: '1rem',
              }}
            >
              REACH OUT
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/support"
                  className="transition-colors active:opacity-75"
                  style={{
                    fontFamily: "'Patrick Hand', cursive",
                    fontSize: '15px',
                    color: '#bfb49e',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fefcf6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#bfb49e';
                  }}
                >
                  Support
                </Link>
              </li>
              <li>
                <a
                  href="mailto:support@voteplan.com"
                  className="transition-colors active:opacity-75"
                  style={{
                    fontFamily: "'Special Elite', monospace",
                    fontSize: '13px',
                    color: '#bfb49e',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#fefcf6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#bfb49e';
                  }}
                >
                  support@voteplan.com
                </a>
              </li>
            </ul>

            {/* Social */}
            <div className="flex gap-4 mt-4">
              <a
                href="https://twitter.com/voteplan"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors active:opacity-75"
                style={{ color: '#bfb49e', textDecoration: 'none' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#fefcf6';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#bfb49e';
                }}
                aria-label="Twitter"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
              <a
                href="https://facebook.com/voteplan"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors active:opacity-75"
                style={{ color: '#bfb49e', textDecoration: 'none' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#fefcf6';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#bfb49e';
                }}
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4"
          style={{ borderTop: '2px dashed #3d3528' }}
        >
          <p
            style={{
              fontFamily: "'Special Elite', monospace",
              fontSize: '13px',
              color: '#8a7e6b',
            }}
          >
            &copy; {currentYear} VotePlan. All rights reserved.
          </p>
          <p
            style={{
              fontFamily: "'Special Elite', monospace",
              fontSize: '11px',
              color: '#6b5f4d',
            }}
          >
            Non-partisan. We don't endorse candidates or parties.
          </p>
        </div>
      </div>
      <BuildVersion />
    </footer>
  );
}
